module.exports = __webpack_public_path__ + "img/strefy-parkowania.7b396d4a.svg";